import {invert, transform} from 'lodash-es';

/**
 * Languages list.
 */
export enum Language {
    /** English */
    EN = 'EN',

    /** Russian */
    RU = 'RU',

    /** Spanish */
    ES = 'ES'
}

export enum Locale {
    en_US = 'en_US',
    ru_RU = 'ru_RU',
    es_ES = 'es_ES'
}

export const LANGUAGE_BY_LOCALE: Record<Locale, Language> = {
    [Locale.en_US]: Language.EN,
    [Locale.ru_RU]: Language.RU,
    [Locale.es_ES]: Language.ES
};

/**
 * angular-l10n lib requires hyphen as delimiter.
 */
export const LANG_HYPHEN_REG_BY_LOCALE: Record<Locale, string> = {
    [Locale.en_US]: 'en-US',
    [Locale.ru_RU]: 'ru-RU',
    [Locale.es_ES]: 'es-ES'
};

export const LOCALE_BY_LANG_HYPHEN = invert(LANG_HYPHEN_REG_BY_LOCALE) as Record<string, Locale>;
